import React, { FC, useState } from 'react';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { MultiSelectOption } from '../../../models/MultiSelectOption';
import List from '../../list/list';

interface Props{
    onBack : (event:any) => void;
    onNext: (event: any) => void;
    setSelectedHand: (selectedHand: MultiSelectOption) => void;
}

const SelectHand: FC<Props> = ({ onBack, onNext, setSelectedHand}) => {
    const {translate} = useLocale();
    const [enableNext, setEnableNext] = useState(false);
    const [value, setValue] = useState<string>('');
    const handOptions = [
        { label: translate.byKey(TranslationKeys.leftHand), value: "2" },
        { label: translate.byKey(TranslationKeys.rightHand), value: "3" },
    ];

    const itemSelected = (item: any) => {
        const selectedItem = item.props['data-item'];
        if (selectedItem) {
            setEnableNext(true);
            setValue(selectedItem.value);
            setSelectedHand({ value: selectedItem.value, label: selectedItem.label })
            onNext({task: selectedItem.value, description: selectedItem.label});
        }
    }

    const getItems = (): { value: JSX.Element; isSelected: boolean; }[] => {
        return handOptions.map(item => {
            return {
                value: (
                    <div className="grid grid-cols-2 gap-3 cursor-pointer select-none" data-item={item}>
                        <div className="flex justify-start">{item.label}</div>
                    </div>
                ),
                isSelected: item.value === value
            };
        })
    }

    const onLocalNext = (event: any) => {
        if (enableNext) {
            onNext({ ...event, value });
        }
    }

    return <div className="pt-3 pr-3 h-full relative">
        <List onSelect={(_, item) => itemSelected(item)} isStriped items={getItems()} />

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${enableNext ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    onClick={e => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default SelectHand;
